import * as angular from 'angular';

import { InformationDTO } from '../../models/DTO';
import { IRequestService } from '../../services';

export interface IInformationService {
    getAll(): angular.IPromise<InformationDTO[]>;
    getById(id: number): angular.IPromise<InformationDTO>;
    getFirst(): angular.IPromise<InformationDTO>;
    getLast(): angular.IPromise<InformationDTO>;
    getBetween(beginDate: string, endDate: string): angular.IPromise<InformationDTO[]>;
    getTimestamps(dates: Date[]): angular.IPromise<InformationDTO[]>;
    validate(informations: InformationDTO[]): angular.IPromise<InformationDTO[]>;
}

export class InformationService implements IInformationService {
    static serviceId = 'informationService';

    static $inject = ['requestService'];

    constructor(
        private _requestService: IRequestService) {
    }

    private controllerUrl(): string {
        return this._requestService.getUrlV1() + 'information';
    }

    getAll(): angular.IPromise<any> {
        const url = this.controllerUrl();
        return this._requestService.get(url);
    }

    getById(id: number): angular.IPromise<any> {
        const url = this.controllerUrl() + id + '/';
        return this._requestService.get(url);
    }

    getFirst(): angular.IPromise<any> {
        const url = this.controllerUrl() + 'first/';
        return this._requestService.get(url);
    }

    getLast(): angular.IPromise<any> {
        const url = this.controllerUrl() + 'last/';
        return this._requestService.get(url);
    }

    getBetween(beginDate: string, endDate: string): angular.IPromise<InformationDTO[]> {
        const url = this.controllerUrl() + '/between/?beginDate=' + beginDate + '&endDate=' + endDate;
        // no cache since approval may be changed
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }

    validate(informations: InformationDTO[]): angular.IPromise<InformationDTO[]> {
        const url = this.controllerUrl() + 'validate/';
        return this._requestService.post(url, informations);
    }

    getTimestamps(dates: Date[]): angular.IPromise<InformationDTO[]> {
        const url = this.controllerUrl() + 'timestamps/';
        // no cache since approval may be changed
        this._requestService.cleanCache(url);
        return this._requestService.post(url, dates);
    }
}
